import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ExposureByLocationGroup } from 'src/app/models/exposureBySeg.model';
import { ErrorConstants } from 'src/app/shared/constants/error.constants';

interface ExposureByLocationGroupVm extends ExposureByLocationGroup {
  changeAbsPercent: string;
  changePercent: number;
}

@Component({
  standalone: false,
  selector: 'app-exposure-by-location-group',
  templateUrl: './exposure-by-location-group.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./exposure-by-location-group.component.scss']
})
export class ExposureByLocationGroupComponent {
  @Input() loading: boolean = true;

  exposureByLocationGroupVm: ExposureByLocationGroupVm[] = [];

  @Input() set exposureByLocationGroup(value: ExposureByLocationGroup[]) {
    this.exposureByLocationGroupVm = (value || []).map(task => {
      const changePercent = (task?.change ?? 0) * 100;
      return {
        ...task,
        changePercent,
        changeAbsPercent: Math.abs(changePercent).toFixed(2),
      };
    });
  }

  errorHtml: string = "";

  constructor(
  ) {
    this.errorHtml = ErrorConstants.errorHtml;
  }

  public trackByIndex = trackByIndex;
}
